<template>
  <div>
      <h2 class="editor-header">{{ $t('contracts.close_orders') }}</h2>
      <div v-if="tieraApiKeyAllowed">
          <div class="form-check form-switch">
              <input
                  class="form-check-input pe-3"
                  type="checkbox"
                  id="sendToTiera"
                  v-model="sendToTiera"
              >
              <label class="form-check-label ms-2" for="sendToTiera">
                  {{ $t('daily_summary.send_to_tiera') }}
              </label>
          </div>
          <span class="tip-light">{{ $t('daily_summary.send_to_tiera_description') }}</span>
          <hr/>
      </div>

      <div v-if="selectedOrders.length > 0" class="mt-2 mb-2">
          <div v-for="order in selectedOrders" :key="order.id" class="d-flex justify-content-between align-items-center py-2">
              <span>{{ order.id }} - {{ getOrderStringWithInfo(order) }}</span>
              <order-status-badge
                  :item-id="order.id"
                  :status="order.status"
                  :edit-allowed="false"
              />
          </div>
      </div>
      <div class="col-12 button-container">
          <button
              class="form-button btn btn-sm btn-secondary"
              @click="close"
          >
              {{ $t('common.cancel') }}
          </button>
          <button
              class="form-button btn btn-sm btn-success"
              :disabled="loading"
              @click="doCloseOrders"
          >
              {{ $t('common.save') }}
          </button>
      </div>
      <div
          v-if="loading"
          id="loader"
          class="spinner"
      />
  </div>
</template>

<script>
import OrderStatusBadge from "../contractcalendar/OrderStatusBadge.vue";
import {inject} from "vue";
import {restApi} from "../mixins/RestApiMixin.js";
import {orderMixin} from "../mixins/OrderMixin.js";

export default {
    name: 'BulkOrderCloser',
    components: {OrderStatusBadge},
    mixins: [restApi, orderMixin],
    props: {
        selectedOrders: {
          type: Array,
          required: true
        },
        tieraApiKeyAllowed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            sendToTiera: false,
            loading: false
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    methods: {
      doCloseOrders: function () {
          this.closeOrdersModal = false
          this.loading = true
          let orderIds = []
          if (this.selectedOrders.length > 0) {
              this.selectedOrders.forEach(item => {
                  orderIds.push(item.id)
              })
          } else {
              this.orders.forEach(item => {
                  orderIds.push(item.id)
              })
          }
          if (this.sendToTiera) {
              this.restUpdate(this.orderSendTieraUrl, {orders: orderIds}, this.handleSendOrders, this.handleCloseOrdersFail)
          } else {
              this.restUpdate(this.orderCloseUrl, {orders: orderIds}, this.handleCloseOrders, this.handleCloseOrdersFail)
          }
      },
      handleSendOrders: function () {
          let orderIds = []
          if (this.selectedOrders.length > 0) {
              this.selectedOrders.forEach(item => {
                  orderIds.push(item.id)
              })
          } else {
              this.orders.forEach(item => {
                  orderIds.push(item.id)
              })
          }
          this.restUpdate(this.orderCloseUrl, {orders: orderIds}, this.handleCloseOrders, this.handleCloseOrdersFail)
      },
      handleCloseOrders: function () {
          this.loading = false
          this.$emit('closeAndUpdate')
      },
      handleCloseOrdersFail: function () {
          this.loading = false
          this.showAlert(this.$t('contracts.close_error'))
      },

      close() {
        this.$emit('close')
      }
  }
}
</script>

<style scoped>
</style>
